import { h } from 'preact';
import * as BaseComp from 'base/showtimes/showtimesApp.js';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import Store from 'store/store';
import * as actions from 'store/actions';
import { Link } from 'components/core/link/link';
import s from 'base/showtimes/showtimesApp.sss';

export default class ShowtimesApp extends BaseComp.default {
	constructor(props) {
		super(props);

		this.state.sideNavOpen = false;

		this.toggleSwitcherOpen = this.toggleSwitcherOpen.bind(this);
	}

	componentDidMount() {
		super.componentDidMount();

		Store.on(actions.SET_ACTIVE_PAGE, () => {
			// document.getElementById('showtimesApp').scrollTop = 0;
			// if (this.state.regionSwitcherOpen) {
			// 	this.toggleSwitcherOpen();
			// }
		});

		Store.on(actions.SET_SIDE_NAV_OPEN, (open) => {
			if (open) {
				this.scrollTop = document.body.scrollTop;
				Store.emit(actions.SCROLL_LOCK);
				document.body.scrollTop = this.scrollTop;
			} else {
				Store.emit(actions.SCROLL_UNLOCK);
				document.body.scrollTop = this.scrollTop;
			}
			this.setState({ sideNavOpen: open });
		});
	}

	renderRegionToggle(data) {
		const list = sortObjectByOrder(data);
		const activeRegion = accessNested(this.state, 'appState.appData.meta.region.slug');

		return (
			<div class={s.regionToggle}>
				{list.map(region => {
					const isActive = region.code === activeRegion;
					let href = region.url;
					if (__IS_DEMO__ || __IS_LOCAL__) {
						href = region.demoUrl;
					}
					return (
						<Link
							href={isActive ? 'javascript:void(0)' : href}
							class={joinClasses(s.region, isActive && s.active)}
						>
							{region.label}
						</Link>
					);
				})}
			</div>
		);
	}

	toggleSwitcherOpen() {
		const { id } = Store.get().activePage;
		if(id === 'regionSelector') {
			window.history.back();
		} else {
			window.goToPage('regionSelector');
		}
	}

	getExtra() {
		const regionSwitcher = accessNested(this.state, 'appState.appData.pages.regionSelector');
		const regionToggle = accessNested(this.state, 'appState.appData.header.regionToggle');
		const { sideNavOpen } = this.state;

		if (regionSwitcher) {
			return (
				<div class={joinClasses(s.extra, sideNavOpen && s.hide)}>
					<div class={joinClasses(s.logo, sideNavOpen && s.hide, regionToggle && s.regionToggleUsed)} />
					{regionToggle && this.renderRegionToggle(regionToggle)}
					<div
						onClick={this.toggleSwitcherOpen}
						class={joinClasses(s.flag, regionToggle && s.regionToggleUsed)}
					/>
				</div>
			);
		}
	}
}
